// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sm-GeologicBodyOperation-btn[data-v-fab16430] {\n  padding: 2px 6px;\n  margin: 10px 2px 0px 2px;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: center;\n  color: darkgrey;\n  border: 1px solid #686363;\n  vertical-align: middle;\n  cursor: pointer;\n  border-radius: 0px;\n  background-color: rgba(38, 38, 38, 0.75);\n}\n.sm-GeologicBodyOperation-input[data-v-fab16430] {\n  float: none;\n  width: 20%;\n}\n", ""]);
// Exports
module.exports = exports;
